import { AEMLink } from '@msc-b2c/interfaces/types';
import { useEffect, useState } from 'react';
import {
  closeLoader,
  constructPageViewData,
  createAemRegistry,
  fetchRouteAemPageContent,
  openLoader,
  RootState,
  scrollToTop,
  trackEvent,
} from '@msc-b2c/shared-utils';
import { wrappers } from '../wrappers';
import { render } from '@msc-b2c/shared-components';
import { TransformedNode } from '@msc-b2c/interfaces/interfaces';
import { enrichPrivateAreaPageView } from '../utils/analyticsUtils';
import { useSelector } from 'react-redux';

export function NavigationRoute(urlLink: Readonly<AEMLink>) {
  const [htmlContent, setHtmlContent] = useState('');
  const [routeModelJson, setRouteModelJson] = useState<TransformedNode | null>(null);
  const [isLoading, setIsLoading] = useState(true);
  const registry = createAemRegistry(false, wrappers as never[]);
  const { membershipData } = useSelector((state: RootState) => state.myCruise);

  function injectAnalyticsScript(scriptContent?: string) {
    const previousScriptElement = document.getElementById('analytics-script');
    if (previousScriptElement) {
      previousScriptElement.remove(); // Remove the previous script if it exists
    }
    const script = document.createElement('script');
    script.id = 'analytics-script';
    if (scriptContent) {
      // Remove script tags if they exist
      script.textContent = scriptContent.replace(/<script.*?>/g, '').replace(/<\/script>/g, '');
    }

    document.head.appendChild(script);
    window.containerMappingRefresh(); // Refresh the container mapping after script injection
  }

  useEffect(() => {
    document.querySelector('body')?.classList.toggle('is-navigation-page', true);
  }, []);

  useEffect(() => {
    const fetchHtml = async () => {
      try {
        if (urlLink?.url) {
          openLoader('.loader');

          const baseUrl = urlLink.url.replace('.html', '');
          const htmlUrl = `${baseUrl}/jcr:content/root/container${
            window.location.href.includes('.html') ? `.content.html` : ``
          }`;
          const scriptUrl = `${baseUrl}.mymscanalytics.html`;

          const [html, script] = await Promise.all([
            fetch(htmlUrl).then((res) => res.text()),
            fetch(scriptUrl).then((res) => res.text()),
          ]);

          setHtmlContent(html);
          injectAnalyticsScript(script);

          const pageViewData = enrichPrivateAreaPageView(constructPageViewData(), membershipData);
          trackEvent('page_view', pageViewData);

          if (Array.isArray(window.adobeDataLayer)) {
            window.adobeDataLayer.forEach((item, index) => {
              if (
                index > 0 &&
                item.event === 'page_view' &&
                window.adobeDataLayer[index].page?.virtual_page_name &&
                window.adobeDataLayer[index].page.virtual_page_name ===
                  window.adobeDataLayer[index - 1].page?.virtual_page_name
              ) {
                window.adobeDataLayer.splice(index - 1, 1);
              }
            });
          }
        }
      } catch (error) {
        console.error('Error fetching AEM page: ', error);
      }
    };

    if (urlLink?.url) {
      setIsLoading(true);
      scrollToTop();

      fetchHtml().then(() =>
        fetchRouteAemPageContent(urlLink?.url).then((data) => {
          setRouteModelJson(data);
          setIsLoading(false);
          closeLoader('.loader');
        })
      );
    }
  }, [urlLink?.url]);

  return (
    <div style={isLoading ? { visibility: 'hidden' } : undefined}>
      <div
        className="cmp-navigation-route"
        data-navigation-route={urlLink?.url}
        dangerouslySetInnerHTML={{ __html: htmlContent }}
      ></div>
      {routeModelJson?.nodes?.map(render.bind(null, { registry }))}
    </div>
  );
}
